function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 15.5C7.20833 15.5 5.99479 15.1875 4.85938 14.5625L0 16.5L1.9375 11.6406C1.3125 10.5052 1 9.29167 1 8C1 6.97917 1.19792 6.00781 1.59375 5.08594C1.98958 4.16406 2.52344 3.36719 3.19531 2.69531C3.86719 2.02344 4.66406 1.48958 5.58594 1.09375C6.50781 0.697917 7.47917 0.5 8.5 0.5C9.52083 0.5 10.4922 0.697917 11.4141 1.09375C12.3359 1.48958 13.1328 2.02344 13.8047 2.69531C14.4766 3.36719 15.0104 4.16406 15.4062 5.08594C15.8021 6.00781 16 6.97917 16 8C16 9.02083 15.8021 9.99219 15.4062 10.9141C15.0104 11.8359 14.4766 12.6328 13.8047 13.3047C13.1328 13.9766 12.3359 14.5104 11.4141 14.9062C10.4922 15.3021 9.52083 15.5 8.5 15.5ZM11 9.5H10L9.4375 10C8.96875 9.875 8.39323 9.47135 7.71094 8.78906C7.02865 8.10677 6.625 7.53125 6.5 7.0625L7 6.5V5.5C7 5.32292 6.9375 5.14583 6.8125 4.96875C6.6875 4.79167 6.54948 4.66406 6.39844 4.58594C6.2474 4.50781 6.14062 4.5 6.07812 4.5625L5.34375 5.29688C4.9375 5.70312 4.8776 6.33594 5.16406 7.19531C5.45052 8.05469 5.9974 8.88802 6.80469 9.69531C7.61198 10.5026 8.44531 11.0495 9.30469 11.3359C10.1641 11.6224 10.7969 11.5625 11.2031 11.1562L11.9375 10.4219C12 10.3594 11.9922 10.2526 11.9141 10.1016C11.8359 9.95052 11.7083 9.8125 11.5312 9.6875C11.3542 9.5625 11.1771 9.5 11 9.5Z",
  fill: "#1F2145"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.75c2a1cc.svg";
export { ForwardRef as ReactComponent };